import { render, staticRenderFns } from "./PageCalculadoraItpEsp.vue?vue&type=template&id=30651d9c&scoped=true&"
import script from "./PageCalculadoraItpEsp.vue?vue&type=script&lang=js&"
export * from "./PageCalculadoraItpEsp.vue?vue&type=script&lang=js&"
import style0 from "./PageCalculadoraItpEsp.vue?vue&type=style&index=0&id=30651d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30651d9c",
  null
  
)

export default component.exports